import React from 'react'
import styled from "styled-components";
import { ProductConsumer } from '../../../Context/AddProWakel';
export const EditModel = () => {
    return (
        <ProductConsumer>
            {(value) => {
                const {
                    AddProChange,
                    IT_isEdited,
                    IT_dana,
                    IT_itemName,
                    IT_ItemData,
                    IT_updateItemInTable,
                    IT_closeModel,
                    IT_onKeyUP,
                    IT_karton,
                    IT_darzan,
                    IT_OnDanaChange,
                    IT_OnDarzanChange,
                    IT_OnKartonChange,
                    IT_nrx
                } = value;

                if (!IT_isEdited) {
                    return null;
                } else {
                    return (
                        <>
                            <ModalContainer>
                                <div className="container">
                                    <div className="row">
                                        <div
                                            id="modal"
                                            className="col-lg-8 col-sm-12 mx-auto col-9 col-lg-7 text-center text-capitalize p-5"
                                        >
                                            <div className="row">
                                                <div className="col-2">
                                                    <div className="form-group">
                                                        <label>نرخ</label>
                                                        <input
                                                            type="text"
                                                            name="IT_nrx"
                                                            value={IT_nrx}
                                                            onChange={AddProChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-right font-weight-bold"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-2">
                                                    <div className="form-group">
                                                        <label>دانە</label>
                                                        <input
                                                            type="text"
                                                            name="IT_dana"
                                                            value={IT_dana}
                                                            onChange={IT_OnDanaChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-right font-weight-bold"
                                                            id='IT_dana'
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-2">
                                                    <div className="form-group">
                                                        <label>دەرزەن</label>
                                                        <input
                                                            type="text"
                                                            name="IT_darzan"
                                                            value={IT_darzan}
                                                            onChange={IT_OnDarzanChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-right font-weight-bold"

                                                        />
                                                    </div>
                                                </div>
                                                {/* <div className="col-2">
                                                    <div className="form-group">
                                                        <label>کارتۆن</label>
                                                        <input
                                                            type="text"
                                                            name="IT_karton"
                                                            value={IT_karton}
                                                            onChange={IT_OnKartonChange}
                                                            onKeyUp={(e) => IT_onKeyUP(e, IT_ItemData)}
                                                            className="form-control text-right font-weight-bold"

                                                        />
                                                    </div>
                                                </div> */}
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label>ناوی کاڵا</label>
                                                        <input
                                                            type="text"
                                                            name="IT_itemName"
                                                            value={IT_itemName}
                                                            className="form-control text-right font-weight-bold"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="row">
                                                <div className="col-6">
                                                    <button
                                                        className="btn btn-info"
                                                        onClick={(e) => {
                                                            IT_updateItemInTable(e, IT_ItemData);
                                                        }}
                                                    >
                                                        {("پاشەکەوتکردن")}
                                                    </button>
                                                </div>
                                                <div className="col-6">
                                                    <button
                                                        className="btn btn-success"
                                                        onClick={() => IT_closeModel()}
                                                    >
                                                        {("داخستن")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ModalContainer>
                        </>
                    );
                }
            }}
        </ProductConsumer>
    );
};


const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  #modal {
    background: #f3e29f;
  }
`;